const MobileMenuButton = ({ value, onChange }) => {
	return (
		<button
			aria-expanded="false"
			className="sm:hidden inline-flex items-center justify-center p-1 -mt-2 rounded-md text-gray-400 hover:text-white hover:bg-yellow-500"
			onClick={() => onChange && onChange(!value)}
		>
			<span className="sr-only">Open main menu</span>
			{value
				? <i className="material-icons">close</i>
				: <i className="material-icons">menu</i>
			}
		</button >
	)
}

export default MobileMenuButton